import { useEffect, useState } from "react";
import { useAuthState } from "../../context/AuthContext";
import PrivateApi from "../../services/PrivateApiService";
import { useQuery } from "react-query";
import { Col, Container, Row } from "react-bootstrap";
import EnergoTooltip from "../../components/shared/EnergoTooltip";
import InvoiceClassCard from "../../components/shared/InvoiceClassCard";
import DownloadInvoiceList from "../../components/downloadPage/DownloadInvoiceList";
import SplashPage from "../SplashPage";

const DownloadPage = () => {

    const API = new PrivateApi();
    const { user } = useAuthState();
    const [selectedInvoiceType, setSelectedInvoiceType] = useState([])
    const [sortedInvoices, setSortedInvoices] = useState([]);
    const [types] = useState([
        { id: "poolrechnungCard", name: "Poolrechnungen", count: 0, last: ""},
        { id: "abrechnungenCard", name: "Energielieferant", count: 0, last: ""},
        { id: "vorschreibungCard", name: "Vorschreibungen", count: 0, last: ""},
    ]);
    const [hideQuickAccessCards, setHideQuickAccessCards] = useState(false);

    //! get invoices from backend
    const { data, error, isLoading} = useQuery("GET_ALL_INVOICES", API.get_InvoicesUser, {staleTime: Infinity});

    useEffect(() => {
        if (data) {
            var tempList = []
            if (data.data.poolrechnungen.length > 0) {
                tempList = [...tempList, ...data.data.poolrechnungen];
                types[0].count = Number(data.data.poolrechnungen.length);
                types[0].last = new Date(data.data.poolrechnungen[0].create_date).toLocaleDateString('DE-de');
                selectedInvoiceType.push(types[0].id);
            }
            if (data.data.abrechnungen.length > 0) {
                tempList = [...tempList, ...data.data.abrechnungen];
                types[1].count = Number(data.data.abrechnungen.length);
                types[1].last = new Date(data.data.abrechnungen[0].create_date).toLocaleDateString('DE-de');
                selectedInvoiceType.push(types[1].id);
            }
            if (data.data.vorschreibungen.length > 0) {
                tempList = [...tempList, ...data.data.vorschreibungen];
                types[2].count = Number(data.data.vorschreibungen.length);
                types[2].last = new Date(data.data.vorschreibungen[0].create_date).toLocaleDateString('DE-de');
                selectedInvoiceType.push(types[2].id);
            }

            if (tempList.length > 0) {
                tempList.sort((a, b) =>  new Date(a.create_date) > new Date(b.create_date))
            }
            setSortedInvoices([...tempList]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        let tempList = [];
        if (selectedInvoiceType.includes("poolrechnungCard")) {
            tempList = [...tempList, ...data.data.poolrechnungen];
        }
        if (selectedInvoiceType.includes("abrechnungenCard")) {
            tempList = [...tempList, ...data.data.abrechnungen];
        }
        if (selectedInvoiceType.includes("vorschreibungCard")) {
            tempList = [...tempList, ...data.data.vorschreibungen];
        }
        setSortedInvoices(tempList.length ? [...tempList] : []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedInvoiceType])


    if (isLoading) return <SplashPage />
    if (error) return <SplashPage error="Da ist etwas schief gelaufen. Bitte versuchen Sie es später nochmal." />

    //! GUI
    return (
        <Container className="text-start">
            <Row>
                <Col>
                    <div className="flex">
                        <h3 style={{marginRight: 10}}>{user.x_is_house_management? "Download": "Neue Dokumente"}</h3>
                        <EnergoTooltip tKey="5001" position="right" />
                    </div>
                    <p className="text-muted">Hier können Sie Ihre neuesten Dokumente downloaden</p>
                </Col>
            </Row>
            <Row className="mt-5" hidden={hideQuickAccessCards}>
                <h5 className="text-energo">Schnellzugriff</h5>
                {types.map(t => (
                    <InvoiceClassCard 
                        select={setSelectedInvoiceType} 
                        selected={selectedInvoiceType} 
                        type={t} 
                        key={t.id} 
                    />
                ))}
            </Row>
            <Row className="mt-5">
                <Col xs="12">
                    <h5 className="text-energo">Dokumente</h5>
                    <DownloadInvoiceList invoices={[...sortedInvoices]} hideQuickAccess={setHideQuickAccessCards} />
                </Col>
            </Row>
        </Container>
    )
}
export default DownloadPage;